
/** 方向立方体拖动结束原因的有限类型集合。 */
export const ViewportGizmoOrbitDragEndReason = {
  /** 用户正常抬起活动指针。 */
  Completed: 'completed',
  /** 浏览器取消活动指针。 */
  Cancelled: 'cancelled',
  /** 导航器在拖动期间被释放。 */
  Disposed: 'disposed',
} as const;

/** 方向立方体拖动结束原因。 */
export type ViewportGizmoOrbitDragEndReason =
  (typeof ViewportGizmoOrbitDragEndReason)[keyof typeof ViewportGizmoOrbitDragEndReason];

